import { useQuery } from "@tanstack/react-query";
import { berserkr, isSupabaseConfigured } from "../lib/supabase";

export interface ChunkContextLine { chunk_index: number; is_center: boolean; body: string; }
export interface ChunkContext {
  evidence_id: string;
  source_label: string | null;
  evidence_kind: string | null;
  occurred_on: string | null;
  center_index: number;
  chunks: ChunkContextLine[];
}

/** Lazily fetch a cited chunk in its source context (the chunk + its neighbors). */
export function useChunkContext(chunkId: string | null | undefined, enabled: boolean) {
  return useQuery<ChunkContext | null, Error>({
    queryKey: ["chunk-context", chunkId],
    enabled: isSupabaseConfigured() && !!chunkId && enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      if (!chunkId) return null;
      const { data, error } = await berserkr().rpc("fetch_chunk_context", { p_chunk_id: chunkId, p_window: 1 });
      if (error) throw new Error(error.message);
      return (data as ChunkContext) ?? null;
    },
  });
}
